import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { LayoutHeader as Header } from '@/layouts';
import { LayoutFooter as Footer } from '@/layouts';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Home, Search, AlertCircle, ArrowLeft } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useAppData } from "@/contexts/AppDataContext";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { config } = useAppData();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header config={config} />
      
      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12 mt-32 bg-gradient-to-br from-background via-muted/30 to-background">
        <Card className="w-full max-w-2xl shadow-elegant border-border/50 bg-card/80 backdrop-blur-sm">
          <CardContent className="p-8 md:p-12">
            <div className="text-center space-y-6">
              {/* Icon and 404 */}
              <div className="flex justify-center">
                <div 
                  className="relative inline-flex items-center justify-center w-24 h-24 rounded-full"
                  style={{ backgroundColor: `${colors.primary}15` }}
                >
                  <AlertCircle 
                    className="w-12 h-12" 
                    style={{ color: colors.primary }}
                  />
                </div>
              </div>

              {/* Title */}
              <div className="space-y-2">
                <h2 className="text-2xl md:text-3xl font-semibold text-foreground">
                  Página não encontrada
                </h2>
              </div>

              {/* Description */}
              <div className="space-y-3 max-w-md mx-auto">
                <p className="text-muted-foreground text-base md:text-lg">
                  Desculpe, a página que você está procurando não existe ou foi movida.
                </p>
                <p className="text-sm text-muted-foreground">
                  URL solicitada: <code className="px-2 py-1 bg-muted rounded text-xs">{location.pathname}</code>
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
                <Button
                  onClick={() => navigate('/')}
                  size="lg"
                  className="gap-2 text-white"
                  style={{ 
                    background: `linear-gradient(to right, ${colors.button}, ${colors.button}dd)`,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = `linear-gradient(to right, ${colors.button}ee, ${colors.button})`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = `linear-gradient(to right, ${colors.button}, ${colors.button}dd)`;
                  }}
                >
                  <Home className="h-5 w-5" />
                  Ir para Início
                </Button>
                <Button
                  onClick={() => navigate('/estoque')}
                  variant="outline"
                  size="lg"
                  className="gap-2"
                >
                  <Search className="h-5 w-5" />
                  Ver Estoque
                </Button>
                <Button
                  onClick={() => navigate(-1)}
                  variant="outline"
                  size="lg"
                  className="gap-2"
                >
                  <ArrowLeft className="h-5 w-5" />
                  Voltar
                </Button>
              </div>

              {/* Help Text */}
              <div className="pt-6 border-t border-border/50">
                <p className="text-sm text-muted-foreground">
                  Precisa de ajuda? Entre em <a href="/contato" className="underline hover:text-foreground transition-colors" style={{ color: colors.primary }}>contato conosco</a>
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>

      <Footer config={config} />
    </div>
  );
};

export default NotFound;
